import * as t from "io-ts";

export const ServiceConfigValidator = t.intersection([
  t.type({}),
  t.partial({
    transportDisableDemurrage: t.boolean,
  }),
]);

export type ServiceConfig = t.TypeOf<typeof ServiceConfigValidator>;
